import React from 'react'
import { useTranslation } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE } from '../../i18n'
import { STEPS } from '../../lib'
import { useNavigationSteps } from '../Navigation/useNavigationSteps'

export const StepsText = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const {
    context: { currentStep, hideNavbarElements },
  } = useNavigationSteps()

  if (hideNavbarElements) {
    return null
  }

  return (
    <p
      className={`mc-text-color--medium mc-text--center mc-text-md--left mc-mt-md-6 ${className}`}
      id='step-number'
    >
      {t('common.steps', {
        currentStep,
        totalSteps: Object.keys(STEPS).length,
      })}
    </p>
  )
}
